import axios from "axios";
import { globalAction } from "redux-subspace";

import { HttpCodes, tokenType, tokenStatus } from "./constants";

const REGISTER = "REGISTER";
const VALIDATE_REGISTER = "VALIDATE_REGISTER";
const REGISTER_ERROR = "REGISTER_ERROR";
const SET_FIRSTNAME = "SET_FIRSTNAME";
const SET_LASTNAME = "SET_LASTNAME";
const SET_PASSWORD = "SET_PASSWORD";
const SET_CONFIRM_PASSWORD = "SET_CONFIRM_PASSWORD";
const SET_AGREEMENT = "SET_AGREEMENT";
const SET_TOKEN_VALID = "SET_TOKEN_VALID";

export default function adminRegisterReducer(
  state = {
    submittedChange: false,
    password: null,
    confirmPassword: null,
    canSubmit: false,
    error: null,
    firstName: "",
    lastName: "",
    agreement: false,
    isTokenValid: "",
  },
  action
) {
  switch (action.type) {
    case REGISTER:
      return {
        ...state,
        submittedChange: true,
      };
    case REGISTER_ERROR:
      return {
        ...state,
        error: action.data.error,
        submittedChange: false,
      };
    case VALIDATE_REGISTER:
      return {
        ...state,
        canSubmit: action.data.canSubmit,
      };
    case SET_FIRSTNAME:
      return {
        ...state,
        firstName: action.data.firstName,
      };
    case SET_LASTNAME:
      return {
        ...state,
        lastName: action.data.lastName,
      };
    case SET_AGREEMENT:
      return {
        ...state,
        agreement: !state.agreement,
      };
    case SET_PASSWORD:
      return {
        ...state,
        password: action.data.password,
      };
    case SET_CONFIRM_PASSWORD:
      return {
        ...state,
        confirmPassword: action.data.confirmPassword,
      };
    case SET_TOKEN_VALID:
      return {
        ...state,
        isTokenValid: action.data.isTokenValid,
      };
    default:
      return state;
  }
}

export const registerAdmin =
  (token, email, firstName, lastName, password, agreement) =>
  async (dispatch) => {
    try {
      await axios.put(`/api/account/management/admin/registration`, {
        FirstName: firstName,
        LastName: lastName,
        Token: token,
        Email: email,
        Password: password,
        AcceptedTerms: agreement,
      });
    } catch (e) {
      const status = e.response.status;
      let message = "";
      if (status !== HttpCodes.OK && status !== HttpCodes.INTERNAL_ERROR) {
        if (e.response.data && e.response.data.ExceptionMessage) {
          message = e.response.data.ExceptionMessage;
        } else if (e?.response?.data && typeof e?.response?.data === "string") {
          message = e.response.data;
        } else if (status !== HttpCodes.FORBIDDEN) {
          message = "Invalid Token";
        }
      } else {
        message = "Internal Error";
      }

      dispatch(
        globalAction({
          type: REGISTER_ERROR,
          data: {
            error: message,
            submittedChange: false,
          },
        })
      );
      return Promise.reject(message);
    }

    dispatch(
      globalAction({
        type: REGISTER,
        data: {
          status: HttpCodes.OK,
          submittedChange: true,
        },
      })
    );
    return Promise.resolve();
  };

export const validate = () => (dispatch, state) => {
  const { password, confirmPassword, firstName, lastName, agreement } =
    state().adminRegisterReducer;
  const canSubmit =
    password !== null &&
    confirmPassword !== null &&
    password.localeCompare(confirmPassword) === 0 &&
    agreement === true &&
    firstName !== null &&
    lastName !== null;
  return dispatch(
    globalAction({
      type: VALIDATE_REGISTER,
      data: { canSubmit },
    })
  );
};

export const setFirstName = (firstName) => (dispatch) => {
  return dispatch({
    type: SET_FIRSTNAME,
    data: { firstName },
  });
};

export const setLastName = (lastName) => (dispatch) => {
  return dispatch({
    type: SET_LASTNAME,
    data: { lastName },
  });
};

export const setPassword = (password) => (dispatch) => {
  return dispatch({
    type: SET_PASSWORD,
    data: { password },
  });
};

export const setConfirmPassword = (confirmPassword) => (dispatch) => {
  return dispatch({
    type: SET_CONFIRM_PASSWORD,
    data: { confirmPassword },
  });
};

export const setAgreement = () => (dispatch) => {
  return dispatch({
    type: SET_AGREEMENT,
  });
};

export const verifyToken = (token) => (dispatch, state) => {
  const { isTokenValid } = state().adminRegisterReducer;
  if (isTokenValid === "" && token !== null && token !== undefined) {
    axios
      .post(`/api/account/validatetoken`, {
        Token: token,
        TokenType: tokenType.adminInvitation,
      })
      .then((r) => {
        const isTokenValid = r.data.TokenStatus === tokenStatus.valid;
        return dispatch(
          globalAction({
            type: SET_TOKEN_VALID,
            data: { isTokenValid },
          })
        );
      })
      .catch((error) => {
        return dispatch(
          globalAction({
            type: REGISTER_ERROR,
            data: { error },
          })
        );
      });
  }
};

export const mapStateToPropsAdminRegister = (state) => {
  const {
    submittedChange,
    canSubmit,
    password,
    confirmPassword,
    firstName,
    lastName,
    error,
    isTokenValid,
    agreement,
  } = state.adminRegisterReducer;
  return {
    submittedChange,
    canSubmit,
    password,
    confirmPassword,
    error,
    firstName,
    lastName,
    isTokenValid,
    agreement,
  };
};

export const mapDispatchToPropsAdminRegister = {
  registerAdmin,
  validate,
  setFirstName,
  setLastName,
  setPassword,
  setConfirmPassword,
  setAgreement,
  verifyToken,
};
